module.exports = __webpack_public_path__ + "static/contac-68abfc6530962478603b10530c7bb9ce.jpg";